import { render } from "./SectorList.vue?vue&type=template&id=0bfe909d&scoped=true"
import script from "./SectorList.vue?vue&type=script&lang=js"
export * from "./SectorList.vue?vue&type=script&lang=js"

import "./SectorList.vue?vue&type=style&index=0&id=0bfe909d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfe909d"]])

export default __exports__